/* SIZESOFTX
=========================================================================================
* Descripción: Bitácora de operaciones de soporte
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 11/09/2026 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 15/09/2026 | José Luis Aragón   Cervantes     | Corrección de identificador único para DataGrid
* ---------------------------------------------------------------------------------------
*/

import React, { useEffect, useState } from "react";
import { Alert, Box, Chip, CircularProgress, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { esES } from "@mui/x-data-grid/locales";
import { apiBitacora } from "../settings/supportApi";

const normalizarBitacora = (items = []) => {
  if (!Array.isArray(items)) return [];

  return items.map((item, index) => ({
    ...item,
    id:
      item.id ||
      item.uId ||
      item.supportAuditLogId ||
      `${item.fechaUtc || "sin-fecha"}-${item.accion || "accion"}-${index}`,
  }));
};

const BitacoraPage = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    apiBitacora()
      .then((data) => setRows(normalizarBitacora(data)))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  if (error) return <Alert severity="error">{error}</Alert>;
  if (!rows)
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
        <CircularProgress />
      </Box>
    );

  const columns = [
    { field: "fechaUtc", headerName: "Fecha (UTC)", width: 170, valueFormatter: (v) => (v ? new Date(v).toLocaleString("es-MX") : "—") },
    { field: "usuarioNombre", headerName: "Usuario", width: 160 },
    { field: "usuarioEmail", headerName: "Email", width: 200 },
    { field: "accion", headerName: "Acción", width: 180 },
    { field: "detalle", headerName: "Detalle", width: 320, flex: 1 },
    {
      field: "tipo",
      headerName: "Tipo",
      width: 110,
      renderCell: (p) => <Chip size="small" label={p.value} color={p.value === "ADMIN" ? "info" : p.value === "ERROR" ? "error" : "default"} />,
    },
    { field: "ipOrigen", headerName: "IP", width: 130 },
  ];

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Bitácora de operaciones
      </Typography>
      <Box sx={{ height: 600 }}>
        <DataGrid
          rows={rows}
          columns={columns}
          getRowId={(r) => r.id}
          loading={loading}
          localeText={esES.components.MuiDataGrid.defaultProps.localeText}
          pageSizeOptions={[25, 50, 100]}
        />
      </Box>
    </Box>
  );
};

export default BitacoraPage;
